import React from "react";
import { Navigate } from "react-router-dom";

import { useAppSelector } from "../../app/hooks";
import { useAuth } from "../../context/AuthContext";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import ForbiddenPage from "../../pages/forbidden";
import NotFoundPage from "../../pages/notFound";
import { hasPermission, isHiddenPermission } from "../../static/permission";
import AppLayout from "../layout/AppLayout";
import { LoadingState } from "../ui/TableStateRow";

interface PrivateRouteProps {
  path: string;
  element: React.ReactElement;
  permission?: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  path,
  element,
  permission,
}) => {
  const { isAuthenticated } = useAuth();
  const loggingUser = useAppSelector(getLoggingUser);
  const authToken = localStorage.getItem("authToken");

  if (!isAuthenticated && !authToken) {
    return <Navigate to={path} replace />;
  }

  if (!permission) {
    return element;
  }

  if (isHiddenPermission(permission)) {
    return <NotFoundPage />;
  }

  if (!loggingUser?.id) {
    return (
      <AppLayout>
        <LoadingState />
      </AppLayout>
    );
  }

  if (!hasPermission(loggingUser?.permissions, permission)) {
    return <ForbiddenPage />;
  }

  return element;
};

export default PrivateRoute;
